module.exports = __webpack_public_path__ + "static/img/blue-poster-jpg.f1260268.jpg";